var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDdgl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1740641309493,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 13054,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M928 1024h-832a32 32 0 0 1-32-32v-896a32 32 0 0 1 32-32h128a32 32 0 0 1 0 64H128v832h768V128h-96a32 32 0 0 1 0-64h128a32 32 0 0 1 32 32v896a32 32 0 0 1-32 32z",
    fill: "#ffffff",
    "p-id": 13055
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M672 192h-320a32 32 0 0 1-32-32v-128a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32v128a32 32 0 0 1-32 32zM384 128h256V64H384zM736 384h-256a32 32 0 0 1 0-64h256a32 32 0 0 1 0 64zM736 576h-256a32 32 0 0 1 0-64h256a32 32 0 0 1 0 64zM352 384h-64a32 32 0 0 1 0-64h64a32 32 0 0 1 0 64zM352 576h-64a32 32 0 0 1 0-64h64a32 32 0 0 1 0 64zM736 768h-256a32 32 0 0 1 0-64h256a32 32 0 0 1 0 64zM352 768h-64a32 32 0 0 1 0-64h64a32 32 0 0 1 0 64z",
    fill: "#ffffff",
    "p-id": 13056
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdgl);
export default __webpack_public_path__ + "static/media/ddgl.0301caae.svg";
export { ForwardRef as ReactComponent };